import firebase from "@firebase/app";
import "@firebase/auth";
import "@firebase/firestore";
import "@firebase/functions";
import _ from "lodash";
import env from "../env";

if (!firebase.apps.length) {
  firebase.initializeApp(env.firebase);
}

export const auth = firebase.auth();
export const db = firebase.firestore();
export const functions = firebase.functions();


const docsFromSnapshot = snapshot =>
  _.reduce(
    snapshot.docs,
    (docs, doc) => ({
      ...docs,
      [doc.id]: {
        _id: doc.id,
        ...doc.data()
      }
    }),
    {}
  );

const docFromSnapshot = snapshot => {
  const data = snapshot.data();
  return !data || data.deleted
    ? null
    : {
        _id: snapshot.id,
        ...data
      };
};

export const getDocument = async (collectionId, docId) => {
  const snapshot = await db
    .collection(collectionId)
    .doc(docId)
    .get();
  const data = docFromSnapshot(snapshot);
  return { data };
};
